import React from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';

const AdmissionsTable = ({
  admissions,
  lazyParams,
  totalRecords,
  loading,
  onPage,
  onSort,
  handleViewAdmissionDetails,
  handleProcessAdmission,
  getStatusBadge
}) => {

  const actionBodyTemplate = (rowData) => (
    <div >
      {rowData.status === 'draft' && (<div className="flex items-center justify-center space-x-2">
        <Button icon="pi pi-eye" className="p-button-rounded p-button-text p-button-sm hover:bg-blue-50 text-blue-600 border-2 border-blue-200 hover:border-blue-300 transition-all duration-200" onClick={() => handleViewAdmissionDetails(rowData)} tooltip="View Details" tooltipOptions={{ position: 'top' }} />
        <Button icon="pi pi-file-edit" className="p-button-rounded p-button-text p-button-sm hover:bg-red-50 text-green-600 border-2 border-green-200 hover:border-green-300 transition-all duration-200" tooltip="Process Admission" tooltipOptions={{ position: 'top' }}
          onClick={() => handleProcessAdmission(rowData)}
        />
      </div>
      )}
    </div>
  );

  return (
    <div className="min-h-0">
      <DataTable value={admissions} lazy dataKey="id" paginator first={lazyParams.first} rows={lazyParams.rows}
        totalRecords={totalRecords} onPage={onPage} onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder} loading={loading}
        emptyMessage={<div className="text-center py-8">No admissions found</div>} rowsPerPageOptions={[5, 10, 25, 50]}
        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} admissions" responsiveLayout="scroll" showGridlines stripedRows size="small">
        <Column field="admissionNumber" header={<div className="flex text-xs"><i className="pi pi-id-card mr-1 text-xs"></i>Admission</div>} body={(row) => `ADM0${row.id}`} sortable />
        <Column field="firstName" header={<div className="flex items-center text-xs"><i className="pi pi-user mr-1 text-xs"></i>Student Name</div>} body={(row) => `${row.firstName}`} sortable />
        <Column field="className" header={<div className="flex items-center text-xs"><i className="pi pi-book mr-1 text-xs"></i>Class</div>} sortable />
        <Column field="parentName" header={<div className="flex items-center  text-white-700"><i className="pi pi-users mr-1 text-xs"></i>Parent</div>} sortable />
        <Column field="status" header={<div className="flex items-center text-xs"><i className="pi pi-flag mr-1 text-xs"></i>Status</div>} body={(row) => getStatusBadge(row.status)} sortable />
        <Column header={<div className="flex items-center text-xs"><i className="pi pi-cog mr-1 text-xs"></i>Actions</div>} body={actionBodyTemplate} />
      </DataTable>
    </div>
  );
};

export default AdmissionsTable;
